
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11414",
                "data-name": "矩形 11414",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(-0.3 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_351",
        "data-name": "蒙版组 351",
        "class": "cls-2",
        "transform": "translate(0.3 0)"
      },
      "children": [
        {
          "tag": "g",
          "attrsMap": {
            "id": "icon-test",
            "transform": "translate(2.4 2.4)"
          },
          "children": [
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7753",
                "data-name": "路径 7753",
                "class": "cls-3",
                "d": "M14.321,228.738H8.686v-6.608L6.5,225.779l-2.23-1.095,3.162-9.527,3.405-1.824,3.486,4.459ZM9.5,227.928H13.51v-9.851l-2.919-3.73-2.513,1.338L5.24,224.279l.932.446L9.5,219.212Z",
                "transform": "translate(-4.267 -209.538)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7754",
                "data-name": "路径 7754",
                "class": "cls-3",
                "d": "M496.3,230.831h-5.635V219.926l3.486-4.459,3.405,1.824,3.162,9.486-2.23,1.095-2.189-3.649Zm-4.824-.811h4.013V221.3l3.324,5.513.932-.446-2.838-8.554L494.4,216.48l-2.919,3.689Z",
                "transform": "translate(-481.521 -211.631)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7755",
                "data-name": "路径 7755",
                "class": "cls-3",
                "d": "M355.7,214.078a8.077,8.077,0,0,0-5.513,0l-.324-.73a9.2,9.2,0,0,1,6.081,0Z",
                "transform": "translate(-343.347 -208.865)"
              }
            },
            {
              "tag": "path",
              "attrsMap": {
                "id": "路径_7756",
                "data-name": "路径 7756",
                "class": "cls-3",
                "d": "M428.532,4.5h-.811V2.108h.405a.64.64,0,0,0,.649-.649.649.649,0,0,0-1.3,0h-.811a1.459,1.459,0,0,1,2.919,0,1.523,1.523,0,0,1-1.054,1.419V4.5Z",
                "transform": "translate(-418.687)"
              }
            }
          ]
        }
      ]
    }
  ]
})
    }
  